module.exports = __webpack_public_path__ + "img/KWTLogo-2017.1d176499.png";